import React from 'react';
import PropTypes from 'prop-types';

import styles from './style.module.scss';

export const Tab = ({ active, onClick, value, name, 'data-testid': dataTestId }) => {
    return (
        <span
            className={`${styles.rankHeaderLink} ${active && 'active'}`}
            onClick={() => onClick(value)}
            data-testid={dataTestId}
        >
            {name}
        </span>
    );
};

Tab.propTypes = {
    active: PropTypes.bool,
    onClick: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string,
    'data-testid': PropTypes.string,
};

Tab.defaultProps = {
    active: false,
    onClick: () => ({}),
    value: '',
    name: '',
    'data-testid': null,
};

const Tabs = ({ onTabChange, activeTab, tabs, tabHeaderClass, 'data-testid': dataTestId }) => {
    return (
        <div className={`${styles.rankHeaders} ${tabHeaderClass} d-inline`}>
            <div className={`${styles.rankHeaderColumn} d-grid`}>
                {tabs.map((tab) => (
                    <Tab
                        key={tab.value}
                        active={tab.value === activeTab}
                        onClick={onTabChange}
                        data-testid={dataTestId && `${dataTestId}.tab-${tab.value}`}
                        {...tab}
                    />
                ))}
            </div>
        </div>
    );
};

Tabs.propTypes = {
    tabs: PropTypes.instanceOf(Array).isRequired,
    onTabChange: PropTypes.func.isRequired,
    tabHeaderClass: PropTypes.string,
    activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    'data-testid': PropTypes.string,
};

Tabs.defaultProps = {
    activeTab: '',
    tabHeaderClass: '',
    'data-testid': null,
};

export default Tabs;
